import type { HierarchyRectangularNode } from 'd3-hierarchy';

import type { Unit } from '@dynatrace-sdk/units';

import type { Data } from '../../core/components/overlay-tooltip/types.js';
import type { Formatter } from '../../core/types/formatter.js';
import type { InternalTreeMapNode } from '../types/internal.js';
import { getTooltipItem } from './get-tooltip-item.js';

export const buildOverlayTooltipData = (
  node: HierarchyRectangularNode<InternalTreeMapNode>,
  formatter: Formatter,
  unit?: string | Unit,
): Data => {
  const item = getTooltipItem(formatter, node, unit);
  const parentName = node.parent?.data.name;
  const nodeColor =
    node.parent?.data.color?.Default ?? node.data?.color?.Default ?? '';

  const path = [...node.ancestors()]
    .reverse()
    .slice(1)
    .map((n) => n.data.name);
  const children = node.children?.map((c) => c.data.name);

  return {
    geometry: 'treemap',
    header1: parentName ? [parentName] : [],
    metadata: { id: item.id, value: node.data.value, path, children },
    series: [
      {
        name: item.name,
        color: nodeColor,
        value: item.values[0],
      },
    ],
  };
};
